import React from 'react';

import { Box, Typography } from '@mui/material';

import {
  AUTOMATED_DECISION_NOTICE_HEADING_ID,
  AUTOMATED_DECISION_NOTICE_SECTION_ID
} from './constants';
import { SectionHeading } from './SectionHeading';
import { classes } from './styles';

import type { AutomatedDecisionNoticeConfig } from './types';

interface AutomatedDecisionNoticeProps extends AutomatedDecisionNoticeConfig {
  fontFamily?: string;
}

export const AutomatedDecisionNotice: React.FC<AutomatedDecisionNoticeProps> = ({
  title,
  body,
  fontFamily
}) => (
  <Box
    aria-labelledby={AUTOMATED_DECISION_NOTICE_HEADING_ID}
    component="section"
    id={AUTOMATED_DECISION_NOTICE_SECTION_ID}
    sx={classes.automatedDecisionNotice.containerSx()}
  >
    <SectionHeading fontFamily={fontFamily} id={AUTOMATED_DECISION_NOTICE_HEADING_ID}>
      {title}
    </SectionHeading>
    <Typography component="p" sx={classes.automatedDecisionNotice.bodySx()}>
      {body}
    </Typography>
  </Box>
);

export default AutomatedDecisionNotice;
